module.exports = __webpack_public_path__ + "static/media/download.f8a4730e.svg";